import { Box } from "@chakra-ui/react";
import styled from "@emotion/styled";

interface Props<T> {
    children: React.ReactElement<T>;
}

export const StepContainer = styled(Box)`
    border-left: 1.5px solid;
    padding: 1rem;
    position: fixed;
`

export const StepItem = styled(Box)`
    width: 20rem;
    font-size: 15px;
    padding: 0.5rem 0;

    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: stretch;
`

export const StepItemIcon = <T,>(props: Props<T>) => (
    <Box
        width="1.5rem"
        display="flex"
        justifyContent="center"
        alignItems="flex-start"
        {...props}
    />
);

export const StepItemText = styled(Box)`
    flex: 1;
    align-self: flex-start;
    line-height: 15px;
`

export const StepItemTextSkipped = styled(Box)`
    flex: 1;
    align-self: flex-start;
    line-height: 15px;
`

export const StepItemSelectedIndicator = () => (
    <Box 
        height="18px"
        width="2px"
        backgroundColor="blue.300"
    />
);